var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/_cof.js
 **/